var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.availability
    ? _c("span", { class: _vm.classes, style: _vm.paddingStyles }, [
        _c("span", [_vm._v("\n        " + _vm._s(_vm.name) + "\n    ")])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }